import { useState } from "react";
import { faqs } from "@/mocks/melon";

function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary-600">FAQ</p>
          <h2 className="mt-2 font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            关于吃瓜，你可能想问
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">关于榜单刷新、信源核实、投稿授权等问题，都在这里。</p>
        </div>

        <div className="mt-9 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-200" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="flex items-center gap-3 text-sm font-bold text-foreground-950 md:text-[15px]">
                    <span
                      className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-extrabold ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                  <span
                    className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                      isOpen ? "rotate-180 bg-primary-100 text-primary-600" : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-16 md:text-[15px]">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Faq;